import {BLACK, WHITE} from "../styles/colors";

export type ButtonColorsObject = {
  BLACK: string;
}

export type ButtonTextObject = {
  WHITE: string;
}

export const buttonColors: ButtonColorsObject = {
  BLACK: BLACK,
}

export const buttonTextColors: ButtonTextObject = {
  WHITE: WHITE,
}